export default __webpack_public_path__ + "static/media/banner-image.6336434a.webp";